export var TerminalResultState;
(function (TerminalResultState) {
    TerminalResultState["Success"] = "Success";
    TerminalResultState["Failure"] = "Failure";
})(TerminalResultState || (TerminalResultState = {}));
export const PAY_ONLINE_BY_TERMINAL = 'onlineTerminal/pay';
export var ErrorPaymentConditions;
(function (ErrorPaymentConditions) {
    ErrorPaymentConditions["Refusal"] = "Refusal";
    ErrorPaymentConditions["InvalidCard"] = "InvalidCard";
    ErrorPaymentConditions["WrongPIN"] = "WrongPIN";
    ErrorPaymentConditions["Aborted"] = "Aborted";
    ErrorPaymentConditions["NotAllowed"] = "NotAllowed";
    ErrorPaymentConditions["UnreachableHost"] = "UnreachableHost";
    ErrorPaymentConditions["DeviceOut"] = "DeviceOut";
    ErrorPaymentConditions["Busy"] = "Busy";
    ErrorPaymentConditions["Cancel"] = "Cancel";
})(ErrorPaymentConditions || (ErrorPaymentConditions = {}));
export const MAX_RETRIES = 2;
export const DevicePaymentConditions = [
    ErrorPaymentConditions.WrongPIN,
    ErrorPaymentConditions.UnreachableHost,
    ErrorPaymentConditions.DeviceOut,
    ErrorPaymentConditions.UnreachableHost,
];
export const WrongPaymentConditions = [
    ErrorPaymentConditions.Aborted,
    ErrorPaymentConditions.Busy,
    ErrorPaymentConditions.Cancel,
    ErrorPaymentConditions.InvalidCard,
    ErrorPaymentConditions.Refusal,
];
